export const normaliseTaxonomyOptions = (raw) => {
  const list = Array.isArray(raw)
    ? raw
    : Array.isArray(raw?.items)
    ? raw.items
    : Array.isArray(raw?.results)
    ? raw.results
    : [];

  return list
    .map((entry) => {
      if (typeof entry === "string") {
        return { value: entry, label: entry };
      }

      if (entry && typeof entry === "object") {
        const value =
          entry.value || entry.id || entry.key || entry.slug || entry.name;
        const label = entry.label || entry.name || entry.title || value;

        if (value) {
          return { value, label: label || value };
        }
      }

      return null;
    })
    .filter(Boolean);
};
